module.exports = __webpack_public_path__ + "img/zengmenglong.3761d274.jpg";